// extracted by mini-css-extract-plugin
module.exports = {"form":"PhysicianForm_form__1KOI5","footerButtonContainer":"PhysicianForm_footerButtonContainer__1uo1J"};